<template>
  <div class="page-list rating-page">
    <div class="page-title">
      <div class="page-back" @click="$router.go(-1)">
        <svg style="width:24px;height:24px" viewBox="0 0 24 24">
          <path fill="currentColor" d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z"/>
        </svg>
      </div>
      Рейтинг
    </div>

    <div class="summary-card">
      <svg class="summary-icon" viewBox="0 0 24 24">
        <path fill="#fff"
              d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82Z"/>
      </svg>

      <div>
        <div class="summary-value">{{ total }}</div>
        <div class="summary-label">Всего благодарностей в компании</div>
      </div>
    </div>

    <div class="section-card">
      <div class="page-subtitle">Ценности</div>

      <button
        v-for="it in byWorth"
        :key="it.first"
        type="button"
        class="worth-row"
        :class="{ active: selectedWorth === it.first }"
        @click="selectWorth(it.first)"
      >
        <span
          class="worth-badge"
          :style="{ background: getWorth(it.first).color }"
        >
          {{ it.second }}
        </span>

        <div class="worth-info">
          <div class="worth-name">{{ getWorth(it.first).name }}</div>
          <div class="worth-caption">Получено благодарностей</div>
        </div>
      </button>
    </div>

    <div class="section-card">
      <div class="page-subtitle">Сотрудники</div>

      <div
        v-if="currentEmployee"
        class="employee-row employee-row--me"
        @click="openProfile(currentEmployee)"
      >
        <span
          class="rank-badge"
          :style="getRankBadgeStyle(currentEmployee.rank, currentEmployee.backgroundColor)"
        >
          {{ currentEmployee.rank }}
        </span>

        <div class="employee-main">
          <div class="employee-info">
            <div class="employee-name">Вы — {{ getName(currentEmployee.first) }}</div>
            <div class="employee-caption">Ваше место в рейтинге</div>
          </div>
          <div class="employee-score">{{ currentEmployee.second }}</div>
        </div>
      </div>

      <div
        v-for="it in otherEmployees"
        :key="it.first"
        class="employee-row"
        @click="openProfile(it)"
      >
        <span
          class="rank-badge"
          :style="getRankBadgeStyle(it.rank, it.backgroundColor)"
        >
          {{ it.rank }}
        </span>

        <div class="employee-main">
          <div class="employee-info">
            <div class="employee-name">{{ getName(it.first) }}</div>
            <div class="employee-caption">Благодарностей: {{ it.second }}</div>
          </div>
          <div class="employee-score">{{ it.second }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ADMIN_IDS = [15064562551, 312733181, 794286672, 10110522052]

function getBackgroundColor(rank) {
  if (rank === 1) return '#FFD700'; // золото
  if (rank === 2) return '#A8A8A8'; // серебро
  if (rank === 3) return '#CD7F32'; // бронза
  return `hsl(214, 89%, ${68 - Math.min(rank * 2.2, 45)}%)`;
}

function assignRanks(employees) {
  if (!employees?.length) return [];

  const sorted = [...employees].sort((a, b) => b.second - a.second);

  let rank = 1;
  sorted[0].rank = 1;
  sorted[0].backgroundColor = getBackgroundColor(1);

  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i].second < sorted[i - 1].second) {
      rank = i + 1; // dense rank (рекомендуется)
    }
    sorted[i].rank = rank;
    sorted[i].backgroundColor = getBackgroundColor(rank);
  }

  return sorted;
}

export default {
  name: 'HistoryPage',
  data() {
    return {
      selectedWorth: 0,
    }
  },
computed: {
  stats() {
    return this.$store.getters.stats || { worth: [], employee: [] }
  },
  employee() {
    return this.$store.getters.employee || []
  },
  values() {
    return this.$store.getters.values || []
  },
  profile() {
    return this.$store.getters.profile || {}
  },

  employeeMap() {
    return this.employee.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {})
  },

  byWorth() {
    return [...(this.stats.worth || [])]
      .filter(it => it.first !== 999)
      .sort((a, b) => (Number(b.second) || 0) - (Number(a.second) || 0))
  },

  byEmployee() {
    return assignRanks(this.stats.employee || [], 'competition')
      .filter(it => this.employeeMap[it.first])
  },

  currentEmployee() {
    return this.byEmployee.find(it => it.first === this.profile.id) || null
  },

  otherEmployees() {
    return this.byEmployee.filter(it => it.first !== this.profile.id)
  },

  total() {
    const worthList = this.stats.worth || []

    const common = worthList.find(it => it.first === 999)
    if (common) return Number(common.second) || 0

    return worthList
      .filter(it => it.first !== 999)
      .reduce((sum, it) => sum + (Number(it.second) || 0), 0)
  },
},
  methods: {
    canOpenProfile(employeeId) {
      return employeeId === this.profile.id || ADMIN_IDS.includes(this.profile.id)
    },

    openProfile(it) {
      if (!this.canOpenProfile(it.first)) return
      this.$router.push({ path: '/employeeThanks', query: { id: it.first } })
    },

    selectWorth(worth) {
      this.selectedWorth = this.selectedWorth === worth ? 0 : worth
    },

    getName(employeeId) {
      return this.employeeMap[employeeId]?.name || ''
    },

    getWorth(worth) {
      if (worth === 999) {
        return {
          id: 999,
          name: 'Общая',
          description: 'Заработанные СПАСИБО',
          conditions: [],
          color: 'gray'
        }
      }

      return this.values.find(it => it.id === worth) || {
        id: worth,
        name: 'Неизвестная ценность',
        color: '#94a3b8'
      }
    },

    getRankBadgeStyle(rank, fallbackColor) {
      if (rank === 1) {
        return { background: 'linear-gradient(135deg, #f59e0b, #f97316)' }
      }
      if (rank === 2) {
        return { background: 'linear-gradient(135deg, #94a3b8, #cbd5e1)' }
      }
      if (rank === 3) {
        return { background: 'linear-gradient(135deg, #b45309, #f59e0b)' }
      }
      return { background: fallbackColor || getBackgroundColor(rank) }
    }
  }
}
</script>

<style scoped>
.rating-page {
  background: #f4f7fb;
  min-height: 100vh;
  padding-bottom: 24px;
}

.summary-card {
  margin: 16px;
  padding: 16px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  color: #fff;
  background: linear-gradient(135deg, #8c7ae6, #6c5ce7);
  box-shadow: 0 10px 24px rgba(108, 92, 231, 0.25);
}

.summary-icon {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 4px;
}

.summary-label {
  font-size: 13px;
  opacity: 0.92;
}

.section-card {
  margin: 16px;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.page-subtitle {
  margin: 0;
  padding: 16px 16px 10px;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}

.worth-row,
.employee-row {
  border: 0;
  background: transparent;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  text-align: left;
  border-top: 1px solid #eef2f7;
}

.worth-row:first-of-type,
.employee-row:first-of-type {
  border-top: 0;
}

.worth-row.active {
  background: #f3f0ff;
}

.employee-row--me {
  margin: 0 12px 12px;
  border-radius: 14px;
  background: #eef6ff;
  border: 1px solid #dbeafe;
}

.worth-badge,
.rank-badge {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-family: monospace;
  font-size: 13px;
  box-shadow: 0 4px 14px rgba(48, 52, 54, 0.16);
}

.worth-info,
.employee-main {
  flex: 1;
  min-width: 0;
}

.employee-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.worth-name,
.employee-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  line-height: 1.25;
}

.worth-caption,
.employee-caption {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.employee-score {
  min-width: 44px;
  padding: 6px 10px;
  text-align: center;
  border-radius: 999px;
  background: #f8fafc;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}

.stat,
.stat-item,
.amount {
  display: none;
}

@media (max-width: 420px) {
  .summary-card {
    margin: 12px;
    padding: 14px;
  }

  .section-card {
    margin: 12px;
  }

  .worth-row,
  .employee-row {
    padding: 12px;
  }

  .summary-value {
    font-size: 24px;
  }

  .worth-name,
  .employee-name {
    font-size: 14px;
  }
}
</style>